module.exports = __webpack_public_path__ + "assets/media/lunch.ce372d70.mp3";